<div class="container mt-3">
  <div
    class="my-3"
    style="
      color: var(--default-font-color);
      cursor: pointer;
      width: fit-content;
    "
    (click)="mainMenu()"
  >
    <i
      class="fa-solid me-1 fa-arrow-left"
      style="color: var(--default-font-color); font-size: 15px"
    ></i
    >Back
  </div>
  <div class="pb-3">
    <div class="d-flex justify-content-between my-3">
      <p class="fw-bold m-0">{{ newsData?.date }}</p>
      <i
        class="fa-solid fa-share-nodes"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
        style="
          font-size: 20px;
          color: var(--default-font-color);
          cursor: pointer;
        "
      ></i>
    </div>
    <div class="text-center">
      <h1>{{ newsData?.title }}</h1>
    </div>
    <div class="">
      <img
        [src]="newsData?.img || '/assets/logo/chessx-dark-main-logo.svg'"
        class="img-fluid"
        alt=""
      />
    </div>
    <div class="mt-2">
      <p>{{ newsData?.body }}</p>
    </div>
  </div>
  @if(newsData?.htmlContent){
  <div
    class="pb-3"
    [innerHTML]="sanitizer.bypassSecurityTrustHtml(newsData?.htmlContent)"
  ></div>
  }
</div>

<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Share Blog</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="fa-solid close-icon fa-xmark"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="d-flex justify-content-center">
          <i
            class="fa-regular fa-copy"
            data-bs-dismiss="modal"
            (click)="copyLink()"
          ></i>
          <i
            class="fa-brands fa-whatsapp"
            data-bs-dismiss="modal"
            (click)="whatsappLink()"
          ></i>
          <i
            class="fa-brands fa-facebook"
            data-bs-dismiss="modal"
            (click)="facebookLink()"
          ></i>
          <i class="fa-brands fa-x-twitter" data-bs-dismiss="modal"></i>
        </div>
      </div>
    </div>
  </div>
</div>
